import { render, staticRenderFns } from "./SDStatusAdd.vue?vue&type=template&id=0135e13a&scoped=true"
import script from "./SDStatusAdd.vue?vue&type=script&lang=js"
export * from "./SDStatusAdd.vue?vue&type=script&lang=js"
import style0 from "./SDStatusAdd.vue?vue&type=style&index=0&id=0135e13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135e13a",
  null
  
)

export default component.exports